import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras } from '@angular/router';

import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';

import { InventoryEntryDetFacade } from '../../../common/facade/InventoryEntryDetFacade';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';

@Component({
  selector: 'app-inventory-entry-det',
  templateUrl: './inventory-entry-det.component.html',
  styleUrls: ['./inventory-entry-det.component.css']
})
export class InventoryEntryDetComponent implements OnInit {
  loading = false;
  messageLoader = '';
  // alert
  alerts = [];

  rows: any[];
  private _filteredData: any[];

  deliveryCode = '';
  totalEntries = 0;
  inventoryEntries = 0;

  titleDelivery = res.Delivery;
  lblMerchandiseTotalToEntryMayus = res.MerchandiseTotalToEntryMayus;
  lblMerchandiseEntryMayus = res.MerchandiseEntryMayus;
  lblSearch = res.Search;
  lblDepartment = res.Department;
  lblGender = res.Gender;
  lblStyle = res.Style;
  lblVariety = res.Variety;
  lblSize = res.Size;
  lblUnits = res.Units;
  lblDescription = res.Description;
  lblEntryBy = res.EntryBy;
  lblEntryDate = res.EntryDate;
  lblEntryReference = res.EntryReference;
  public extras: NavigationExtras;
  public path = 'inventory/shipments';
  private _storeId = -1;
  private _startDate: string;
  private _endDate: string;
  private _organizationId = null;

  isSpanish = true;

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };

  constructor(
    private _facadeInventoryEntryDet: InventoryEntryDetFacade
    , private _activatedRoute: ActivatedRoute
    , public strings: Strings
  ) { }

  ngOnInit() {
    this.loading = true;

    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    const id = this._activatedRoute.snapshot.paramMap.get('id');
    this.deliveryCode = id;
    this._activatedRoute.queryParams.subscribe(params => {
      this._storeId = Number(params['storeid']);
      this._startDate = params['startDate'];
      this._endDate = params['endDate'];
      this._organizationId = params['organizationid'];
      this.extras = {
          queryParams: {
              'storeid': this._storeId
              , 'startDate': this._startDate
              , 'endDate': this._endDate
              , 'organizationid': this._organizationId
          }
      };
    });

    this._facadeInventoryEntryDet.GetResumeByDeliveryCode(id, this._organizationId).subscribe(result => {
      if (result.completed) {
        this.rows = result.data;
        this._filteredData = result.data;

        let totalEntriesAux = 0;
        let inventoryEntriesAux = 0;

        this.rows.forEach(r => {
          totalEntriesAux += r.totalQuantity;

          if (r.endEntryDate != null) {
            inventoryEntriesAux += r.totalQuantity;
          }
        });

        this.totalEntries = totalEntriesAux;
        this.inventoryEntries = inventoryEntriesAux;

        this.loading = false;

      } else {
        this.addAlert('<strong>' + this.strings.GetText(res.AlertErrorGettingCatalogs) + '</strong>', 'danger');
        this.loading = false;
      }
    }, error => {
        this.addAlert('<strong>' + error + '</strong>', 'danger');
        this.loading = false;
    });
  }

  // añadir alert
  addAlert(message: String, type: String) {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent) {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();

    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);

    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
      // iterate through each row's column data
      for (let i = 0; i < keys.length; i++) {
        if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
          return true;
        }
      }
    });
  }

}
